import Vue from 'vue'
// collapse 展开折叠
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
// import 'https://resources1.interface003.com/web20/css/theme-chalk/index.css'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import { Slider, Button, Dialog, Switch, Upload, Input, Carousel, CarouselItem, Popover, Rate, Select, Option, OptionGroup, Autocomplete, Collapse, CollapseItem, Form, FormItem, Radio, RadioGroup, RadioButton, Image, Table, TableColumn, DatePicker, Checkbox, CheckboxButton, CheckboxGroup, Pagination, Message, Drawer, TimeSelect, Divider, MessageBox, Tooltip, TabPane, Tabs } from 'element-ui'

const components = [Slider, Tooltip, Button, Dialog, Switch, Upload, Input, Carousel, CarouselItem, Popover, Rate, Select, Option, OptionGroup, Autocomplete, Collapse, CollapseItem, Form, FormItem, Radio, RadioGroup, RadioButton, Image, Table, TableColumn, DatePicker, Checkbox, CheckboxButton, CheckboxGroup, Pagination, Message, CollapseTransition, Drawer, TimeSelect, Divider, MessageBox, TabPane, Tabs]
let messageDom = null
const resetMessage = (options) => {
  if (messageDom) messageDom.close() // 判断弹窗是否已存在,若存在则关闭
  messageDom = Message(options)
}
// message类型
const typeArr = ['success', 'error', 'warning', 'info']
typeArr.forEach((type) => {
  resetMessage[type] = (options) => {
    if (!options) return
    if (typeof options === 'string') options = { message: options }
    console.log(options, 'options')
    options.type = type
    return resetMessage(options)
  }
})
Vue.prototype.$message = resetMessage
Vue.prototype.$confirm = MessageBox.confirm
const Element = {
  install(Vue) {
    components.forEach((component) => {
      Vue.component(component.name, component)
    })
  }
}
// 设置语言
locale.use(lang)
Vue.use(Element)
